import { Component, Input } from '@angular/core';

/** Stat/KPI card. Value renders as-is (pre-format with erInr for money).
 *  Amounts never animate their digits — the card animates, not the figure. */
@Component({
  selector: 'er-kpi-card',
  template: `
    <div class="er-card er-card--hover er-kpi">
      <div class="er-kpi__label">
        <span class="er-dot" *ngIf="dot" [ngClass]="'er-dot--' + dot"></span>{{ label }}
      </div>
      <div class="er-kpi__value" *ngIf="!loading; else skel">{{ value }}</div>
      <ng-template #skel><div class="er-skel er-skel--title" style="height:30px;width:60%"></div></ng-template>
      <div class="er-kpi__meta" *ngIf="meta && !loading">{{ meta }}</div>
    </div>`
})
export class ErKpiCardComponent {
  @Input() label = '';
  @Input() value: string | number | null | undefined = '—';
  @Input() meta: string | null | undefined;
  @Input() dot: 'success' | 'pending' | 'failed' | 'info' | '' = '';
  @Input() loading = false;
}
